import { DealerCashRuleType } from '@upstart/harmony/lib/constants';

export const CURRENT_YEAR_PLUS_ONE_FOR_USED_CARS = new Date().getFullYear() + 1;
export const LAST_YEAR_FOR_USED_CARS = 1900;
export const MAX_VALUE_FOR_MONETARY_INPUT = 1000000;
export const DEFAULT_DEALER_CASH_RULE_TYPE =
  DealerCashRuleType.PRICE_OFFSET_FIXED_MAX;

// tooltip messages for rule table headers
export const HEADER_TOOLTIPS = {
  MODEL_YEAR_RANGE: `Each Model Year Range has two text inputs. Both Max Year and Min Year should be with in the range between ${CURRENT_YEAR_PLUS_ONE_FOR_USED_CARS} and ${LAST_YEAR_FOR_USED_CARS}. The Max Year should be greater than or equal to the Min year of Model Year Range. The Model Year Range inputs should not be overlapping with other Model Year Range inputs.`,
  SOURCE:
    'The source price for the car, before including offset or cash discount',
  OFFSET: 'The offset value to build into the source price',
  UPDATED: 'The last person to edit the pricing rule',
  OVERRIDE: 'Whether the pricing rule is enabled',
  PRICE: 'The final price of the car, not including incentives',
  DEALER_CASH:
    'You can chose to apply a percentage or a fixed dollar value to be considered into the dealer cash allowance.\nLeaving this field blank will apply 100% of the available dealer cash to the deals.',
};
